export const GENERAL_PHRASES = {
    ALL: 839,
    DRAG_AND_DROP: 16537,
    FAILED: 3391,
    PANEL_TITLE: 16084,
    SAVED: 15999,
    SENT: 16000,
    YES: 8442,
    NO: 8443,
    CANCEL: 189,
    PAGES: 17774,
    CONTINUE: 2199,
    COMING_SOON: 1002,
    PHONE_INFO_TOOLTIP: 21448,
} as const;
